import React from 'react';
import { Button, Form } from 'react-bootstrap';

interface RemovePlacementFieldProps {
    /** The removal is staged: applied after Spara, so Avbryt changes nothing. */
    marked: boolean;
    onChange: (marked: boolean) => void;
    /** E.g. "Platsen finns kvar i listan och kan placeras igen." */
    hint: string;
}

/** "Placering på ritningen" in an object's Redigera form, for an object placed on the current drawing. */
const RemovePlacementField: React.FC<RemovePlacementFieldProps> = ({ marked, onChange, hint }) => (
    <Form.Group className="mb-3">
        <Form.Label>Placering på ritningen</Form.Label>
        <div className="d-flex align-items-center gap-2 flex-wrap">
            {marked ? (
                <>
                    <span className="text-danger">Markören tas bort när du sparar</span>
                    <Button variant="outline-secondary" size="sm" onClick={() => onChange(false)}>Ångra</Button>
                </>
            ) : (
                <>
                    <span>Placerad på ritningen</span>
                    <Button variant="outline-danger" size="sm" onClick={() => onChange(true)}>Ta bort placering</Button>
                </>
            )}
        </div>
        <Form.Text muted>{hint}</Form.Text>
    </Form.Group>
);

export default RemovePlacementField;
